import * as React from "react"
import { useEffect } from "react"
import "../scss/MockupsProPage.scss"

import Seo from "../components/seo/seo"
import Header from "../components/header/header"
import Footer from "../components/footer/footer"
import EditableBanner from "../shared/editable-banner/EditableBanner"

const EASYBOARD_URL_FALLBACK = "https://easyboard.com.ua/"

const Easyboard = ({ pageContext }) => {
  const {
    staticContent,
    menu,
    staticHeaderPage,
    staticEasyboardContent,
    banners,
    recaptchaSettings,
    staticContactsForm,
    staticContactsPage,
  } = pageContext

  const sortedBanners = (banners || []).slice().sort(
    (a, b) => a?.position - b?.position
  )
  const banner =
    sortedBanners.find(b => b.pageName === "EasyBoard") || null

  const buttonLink =
    staticEasyboardContent?.["Button Link"] || EASYBOARD_URL_FALLBACK

  useEffect(() => {
    if (typeof window !== "undefined" && window.innerWidth <= 768) {
      window.location.href = buttonLink
    }
  }, [])

  return (
    <div>
      <div className="container">
        <Header
          menu={menu}
          siteTitle={staticContent?.["<title>"]}
          contents={staticHeaderPage}
          displayLogoLinks={false}
        />

        <Seo
          title={staticContent?.["<title>"]}
          descriptionContent={staticContent?.["<meta> description"]}
          keywordsContent={staticContent?.["<meta> keywords"]}
        />

        <div className="mockups-pro mt-4">
          <div className="row mb-4">
            <h1
              className="col"
              dangerouslySetInnerHTML={{
                __html: staticEasyboardContent?.["Page Header"] || "",
              }}
            />
          </div>

          {banner ? (
            <div className="mb-4">
              <EditableBanner
                text={banner.description}
                bannerBackgroundImage={banner.imageUrl}
              />
            </div>
          ) : (
            staticEasyboardContent?.["Page Image"] && (
              <img
                src={
                  require(`../images/${staticEasyboardContent["Page Image"]}`)
                    .default
                }
                alt="EasyBoard preview"
                className="mockups-pro-page mb-4"
              />
            )
          )}

          <div className="row">
            <h1 className="col">
              {staticEasyboardContent?.["Page Header Details"]}
            </h1>
          </div>

          <div className="row mt-6">
            <h3
              className="col"
              dangerouslySetInnerHTML={{
                __html: staticEasyboardContent?.["Page Promo Text"] || "",
              }}
            />
          </div>

          <div className="special-padding mt-4 mb-6">
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingBottom: "65%",
                height: 0,
                overflow: "hidden",
                background: "#fff",
                boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                borderRadius: "24px",
              }}
            >
              <iframe
                src="https://easyboard.com.ua/"
                sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
                referrerPolicy="no-referrer-when-downgrade"
                title="EasyBoard Embedded"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: "0",
                }}
              />
            </div>

            <div className="mt-4">
              <button
                type="button"
                onClick={() => window.open(buttonLink, "_blank")}
                className="btn btn-primary btn-lg col"
                aria-label="Перейти на сайт EasyBoard"
                title="Відкрити сайт EasyBoard в новій вкладці"
                role="link"
              >
                {staticEasyboardContent?.["Button Text"] || "Перейти на сайт"}
              </button>
            </div>
          </div>
        </div>
      </div>

      <Footer
        recaptchaSettings={recaptchaSettings}
        staticContactsForm={staticContactsForm}
        staticContactsPage={staticContactsPage}
      />
    </div>
  )
}

export default Easyboard
